import React from 'react'
import Navbar from '../../../../components/navbar/Navbar'
import styled from './CompletedLessons.module.css'
import { collection, query, where, getDocs} from "firebase/firestore";
import { auth, db } from '../../../../firebase/firebase';
import { useState, useEffect } from 'react';
import GoBackButton from '../../../../components/buttons/GoBackButton';
import { useTranslation } from 'react-i18next'

const PAGE_SIZE = 30;

const CompletedLessons = () => {

const eventCollectionRef = collection(db, "events")
const [events, setEvents] = useState([]);
const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
const { t } = useTranslation();

  useEffect(() => {
    const fetchStudentEvents = async () => {
      try {
        const studentID = auth.currentUser.uid; 
        const q = query(eventCollectionRef, where("studentID", "==", studentID));
        const querySnapshot = await getDocs(q);
        const now = new Date()
        const fetchedEvents = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            ...data,
            id: doc.id, 
            start: data.start.toDate(), 
            end: data.end.toDate(), 
          };
        }).filter((event) => event.end < now)
          .sort((a, b) => b.start - a.start);
  
        setEvents(fetchedEvents); 
      } catch (error) {
        console.error("Error fetching student events:", error);
      }
    };
  
    fetchStudentEvents(); 
    
  }, []);

  const visibleEvents = events.slice(0, visibleCount);
  const hasMore = visibleCount < events.length;

  return (
    <>
    <Navbar></Navbar>
    <div className={styled.container}>
    <h4>{t('CompletedLessons.Total Completed Lessons')}: {events.length} </h4>
    <div className={styled.lesson}>
      {visibleEvents.map((event) => {
        return (
            <div className={styled.event} key={event.id}>
            <p>{event?.teacherName}</p> 
            <p> {event?.start.toLocaleDateString('en-GB')}  {event?.start.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })} - {event?.end.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</p> 
            </div>
        )
      })}
    </div>
    {hasMore && (
      <button
        type="button"
        className={styled.showMore}
        onClick={() => setVisibleCount((count) => count + PAGE_SIZE)}
      >
        {t('CompletedLessons.Show more')}
      </button>
    )}
     <GoBackButton />
    </div>
    </>
  )
}

export default CompletedLessons
